/**
 * Workflow run schemas — cross-vendor view of every workflow execution
 * Opus has launched.
 *
 * One run = one user (or scheduler) clicking "Run" on a workflow against
 * a specific target. Runs go through queued → running → success | failed | cancelled.
 */
import { z } from "zod";

const WorkflowRunStateSchema = z.enum([
  "queued",
  "running",
  "success",
  "failed",
  "cancelled",
]);
export type WorkflowRunState = z.infer<typeof WorkflowRunStateSchema>;

const WorkflowRunSchema = z.object({
  /** Server-issued id — usually the celery task id. */
  id: z.string(),
  workflowSlug: z.string(),
  workflowName: z.string(),
  vendor: z.enum(["meraki", "aruba", "shasta", "system"]),
  /** Site or network the workflow ran against — display string only. */
  target: z.string(),
  triggeredBy: z.string(),
  triggeredAt: z.string(),
  state: WorkflowRunStateSchema,
  /** 0–100, only meaningful while state === "running". */
  progressPct: z.number().min(0).max(100).optional(),
  /** Total runtime in ms — populated once the run reaches a terminal state. */
  durationMs: z.number().optional(),
  /** Optional one-line message — error text on failure, summary on success. */
  message: z.string().optional(),
  /** Was this triggered by the cron scheduler instead of a user? */
  scheduled: z.boolean().optional(),
});
export type WorkflowRun = z.infer<typeof WorkflowRunSchema>;
export const WorkflowRunListSchema = z.array(WorkflowRunSchema);
